﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { ITorusNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.TorusNode,
})
export class TorusNode extends PrimitiveMeshNode implements ITorusNode {
    public constructor() {
        super();
    }
    public radius: number;
    public thickness: number;
    public arc: number;
    public latitudeStart: number;
    public latitudeSlice: number;
    public tessellation: number;
}

export function isTorusMesh(node: Kb3dObject): node is TorusNode {
    return instanceOf(node, Token.TorusNode);
}
